'use strict';Object.defineProperty(exports,'__esModule',{value:!0}),exports.default={DEBUG:{level:1,name:'debug'},INFO:{level:2,name:'info'},WARNING:{level:3,name:'warning'},ERROR:{level:4,name:'error'},NONE:{level:99,name:'none'}};
//# sourceMappingURL=logLevel.js.map


//////////////////
// WEBPACK FOOTER
// /builds/development/frontend/widgets/widgets/node_modules/@sm360/logger-sentry/dist/constants/logLevel.js
// module id = ../../node_modules/@sm360/logger-sentry/dist/constants/logLevel.js
// module chunks = widget-6.25.3